import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import "./Assets.scss";
import Sidebar from "../SideBar/SideBar";
import Loader from "../Loader";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import zec from "../../Img/coins/zec.png";
import xec from "../../Img/coins/xec.png";
import kcs from "../../Img/coins/kcs.png";
import scr from "../../Img/coins/scr.png";
import cat from "../../Img/coins/cat.png";
import woop from "../../Img/coins/woop.png";
import pip from "../../Img/coins/pip.png";
import insp from "../../Img/coins/xec.png";
import ese from "../../Img/coins/ese.png";
import sol from "../../Img/coins/sol.png";
import eye from "../../Img/eye.svg";
import eye_hide from "../../Img/eye_hide.svg";
import reward from "../../Img/reward.webp";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Rewards() {
  const [age, setAge] = useState("");

  const handleSelectChange = (event) => {
    setAge(event.target.value);
  };
  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [imghide, setimghide] = useState([
    { show: true },
    { show: false },
    { show: true },
  ]);

  const assetData = [
    {
      title: "Spot Assets",
      balance: "0.0000",
      depositLink: "#",
      withdrawLink: "#",
      convertLink: "#",
    },
  ];

  const showimg = (i) => {
    setimghide((prevData) =>
      prevData.map((item, index) =>
        index === i ? { ...item, show: !item.show } : item
      )
    );
  };

  const data = [
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: zec,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: xec,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: kcs,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: scr,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: cat,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: woop,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: pip,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: insp,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: ese,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: sol,
    },
  ];

  const filteredData = data.filter((row) => {
    const matchesSearch = row.currencyName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const options = {
    loop: false,
    nav: false,
    dots: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="spot-full menu-responsive">
      <div>
        <Header />
        <Loader />
        <div className="main_flx">
          <Sidebar />
          <div className="dash_board">
            <div className="abvbar split_half display-2 flex-wrap">
              <h6>My Rewards</h6>
              <div className="more-rewards display-1">
                <div className="display-1">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.0257 4.49918C3.24087 4.49918 2.60464 5.1354 2.60464 5.92023V7.00715C2.9225 7.19822 3.19866 7.45457 3.41373 7.76137C3.72874 8.21077 3.8973 8.74646 3.89638 9.29523V9.29684V9.29362V9.29523C3.8973 9.84404 3.72874 10.3797 3.41373 10.8291C3.19866 11.1359 2.9225 11.3922 2.60464 11.5833V12.6702C2.60464 13.455 3.24087 14.0913 4.0257 14.0913H13.973C14.7578 14.0913 15.3941 13.455 15.3941 12.6702V11.5833C15.0763 11.3922 14.8001 11.1359 14.585 10.8291C14.27 10.3797 14.1015 9.84404 14.1024 9.29523C14.1015 8.74646 14.27 8.21077 14.585 7.76137C14.8001 7.45457 15.0763 7.19822 15.3941 7.00715V5.92023C15.3941 5.1354 14.7579 4.49918 13.973 4.49918H4.0257ZM1.18359 5.92023C1.18359 4.35058 2.45605 3.07812 4.0257 3.07812H13.973C15.5427 3.07812 16.8152 4.35058 16.8152 5.92023V7.45248C16.8152 7.75204 16.6273 8.01943 16.3454 8.12096C16.1042 8.20784 15.8958 8.36715 15.7487 8.57707C15.6015 8.78699 15.5228 9.03726 15.5234 9.29362V9.29684C15.5228 9.5532 15.6015 9.80349 15.7487 10.0134C15.8958 10.2233 16.1042 10.3826 16.3454 10.4695C16.6273 10.5711 16.8152 10.8384 16.8152 11.138V12.6702C16.8152 14.2399 15.5427 15.5123 13.973 15.5123H4.0257C2.45605 15.5123 1.18359 14.2399 1.18359 12.6702V11.138C1.18359 10.8384 1.37148 10.5711 1.65332 10.4695C1.89451 10.3826 2.10295 10.2233 2.25009 10.0134C2.39725 9.80349 2.47592 9.5532 2.47533 9.29684V9.29362C2.47592 9.03726 2.39725 8.78699 2.25009 8.57707C2.10295 8.36715 1.89451 8.20784 1.65332 8.12096C1.37148 8.01943 1.18359 7.75204 1.18359 7.45248V5.92023Z"
                      fill="#1D1D1D"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.1582 10.5972C6.1582 10.2048 6.47632 9.88672 6.86873 9.88672H11.1319C11.5243 9.88672 11.8424 10.2048 11.8424 10.5972C11.8424 10.9896 11.5243 11.3078 11.1319 11.3078H6.86873C6.47632 11.3078 6.1582 10.9896 6.1582 10.5972Z"
                      fill="#1D1D1D"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.1582 8.05232C6.1582 7.65991 6.47632 7.3418 6.86873 7.3418H11.1319C11.5243 7.3418 11.8424 7.65991 11.8424 8.05232C11.8424 8.44473 11.5243 8.76285 11.1319 8.76285H6.86873C6.47632 8.76285 6.1582 8.44473 6.1582 8.05232Z"
                      fill="#1D1D1D"
                    />
                  </svg>
                </div>
                <Button> Get More Rewards</Button>
              </div>
            </div>

            <div className="crypto-inr split_half">
              <div className="mb-4">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    {assetData.map((row, i) => (
                      <div className="asset_box box_bdr display-2">
                        <div>
                          <p
                            className={` ${imghide[i].show ? "show" : "hide"}`}
                          >
                            {row.title}
                            <span
                              className="cusrsor-pointer"
                              onClick={() => showimg(i)}
                            >
                              {imghide[i]?.show ? (
                                <img src={eye} alt="img" />
                              ) : (
                                <img src={eye_hide} alt="img" />
                              )}
                            </span>
                          </p>
                          <div className="display-1 select-col">
                            <h2>
                              {imghide[i].show ? row.balance : "*****"} USDT{" "}
                            </h2>
                            <div className="usdt-select">
                              <FormControl fullWidth>
                                <NativeSelect
                                  defaultValue={30}
                                  inputProps={{
                                    name: "age",
                                    id: "uncontrolled-native",
                                  }}
                                >
                                  <option value={10}>Ten</option>
                                  <option value={20}>Twenty</option>
                                  <option value={30}>Thirty</option>
                                </NativeSelect>
                              </FormControl>
                            </div>
                          </div>

                          <div className="flx mt-40">
                            {row.withdrawLink && (
                              <Link
                                to={row.withdrawLink}
                                className="org_btn radius"
                              >
                                Withdraw
                              </Link>
                            )}
                            {row.convertLink && (
                              <Link
                                to={row.convertLink}
                                className="bdr_btn radius"
                              >
                                Transfer
                              </Link>
                            )}
                          </div>
                        </div>

                        <div className="rewadrd-img">
                          <img src={reward} alt="reward-cup" />
                        </div>
                      </div>
                    ))}

                    <div className="mt-50">
                      <h2>Rewards History</h2>
                    </div>
                    <div className="custom_table box_bdr">
                      <TableContainer sx={{ marginBottom: "10px" }}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Time</TableCell>
                              <TableCell>User ID</TableCell>
                              <TableCell>Rewards</TableCell>
                              <TableCell>Amount</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {paginatedData.map((row) => (
                              <TableRow key={row.id} className="tr_row">
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.currencyName}</TableCell>
                                <TableCell>{row.currencySymbol}</TableCell>
                                <TableCell>{row.availableBalance}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15]} // Options for rows per page
                          component="div"
                          count={filteredData.length} // Total number of filtered rows
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableContainer>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <div className="custom_acc box_bdr">
                      <h5>FAQ</h5>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>
                            What is Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            Identity Verification (KYC) is a process where
                            Dreamster-Exchange verifies your identity through
                            personal documents. It's required to access features
                            like withdrawals and rewards.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography>
                            Why do I need to complete Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            Identity Verification is required to comply with
                            regulations, enhance account security, and unlock
                            key features like withdrawals, bonuses, and rewards.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel3a-content"
                          id="panel3a-header"
                        >
                          <Typography>
                            Which documents and information are required for
                            Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            For Identity Verification, you'll need to provide a
                            valid government-issued ID (National ID), proof of
                            address, and a selfie to confirm your identity.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel4a-content"
                          id="panel4a-header"
                        >
                          <Typography>
                            Where can I find help for issues regarding Identity
                            Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            You can find help in the 'Support' section of
                            Dreamster-Exchange or contact customer service
                            directly for assistance with any Identity
                            Verification issues.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="custom_acc box_bdr mt-30">
                      <h5>Begin your Crypto exploration Now!</h5>
                      <div className="mt-20 scan-qr">
                        <Link to="" className="display-1">
                          Scan to Download <QrCode2Icon />
                        </Link>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
